/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-03-03 10:31:06
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\specialmaterial\productProcessing.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/processingFee/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/processingFee/saveProcessingFee'
export function deleteProcessingFee(data) {
  return request({
    url: '/icps/system/sign/intelligent/processingFee/deleteProcessingFee',
    method: 'post',
    data
  })
}
export function queryJurisdictionCompanyList(params) {
  return request({
    url: '/base/system/base/organization/queryJurisdictionCompanyList',
    method: 'get',
    params
  })
}